import {Injectable} from '@angular/core';
import { CONFIG } from '../constants/config.constants';
import { AuthServerProvider } from '..';
import { Http } from '@angular/http';
import { LocalStorageService } from 'ng2-webstorage';
import { API } from '../constants/api.constants';

@Injectable()
export class TemplateType {
    template = CONFIG.templateName;
    customerIndexs = CONFIG.customerIndexs;
    
    private resourceUrlGetCustomerIndex = API.host + 'InvoicePortal/customer-index';

    constructor(
        private authServerProvider: AuthServerProvider,
        private http: Http,
        private $localStorage: LocalStorageService,
        ) {}

    isTemplateShinhan(templateName) {
        if (templateName === this.template.ShinhanGroup) {
            return true;
        }
        return false;
    }

    isTemplateHuaNan(templateName) {
        if (templateName === this.template.HuaNanDetail) {
            return true;
        }
        return false;
    }

    isTemplateMega(templateName) {
        if (templateName === this.template.MegaDetail) {
            return true;
        }
        return false;
    }
    isTemplateBIDC(templateName) {
        if (templateName === this.template.BIDCGroup) {
            return true;
        }
        return false;
    }
    isTemplateMultiTax(templateName) {
        if (templateName === this.template.HuaNanDetail) {
            return true;
        }
        return false;
    }

    whatBank(data, isStore: boolean = false) {
        let customerIndex = this.$localStorage.retrieve('cindex');
        if (customerIndex != undefined || customerIndex != null) {
            this.checkBank(data, customerIndex);
        }
        else {
            this.getCustomerIndex(data);
        }

        if (isStore === true) {
            this.getCustomerIndex(data);
        }
    }

    getCustomerIndex(data) {
        let callAPI = this.callAPIGetCustomerIndex();

        callAPI.subscribe(responseIndex => {
            this.$localStorage.store("cindex", responseIndex);
            this.checkBank(data, responseIndex);
        });
    }

    callAPIGetCustomerIndex() {
        let callAPI = this.http
        .get(`${this.resourceUrlGetCustomerIndex}`)
        .map((res: any) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }
            return res.json().data;
        });
        return callAPI;
    }

    checkBank(data, cusIndex){
        let banksCheck = ['isHuanan','isShinhan','isMega','isSino','isBIDC',]
        banksCheck.forEach(element => {
            if (data[element])
                data[element] = false;
        });
        if (cusIndex == this.customerIndexs.HuaNan) {
            data.isHuanan = true;
        }
        if (cusIndex == this.customerIndexs.Shinhan) {
            data.isShinhan = true;
        }
        if (cusIndex == this.customerIndexs.Mega) {
            data.isMega = true;
        }
        if (cusIndex == this.customerIndexs.Sino) {
            data.isSino = true;
        }
        if (cusIndex == this.customerIndexs.BIDC) {
            data.isBIDC = true;
        }
    }
}
